import React, { ComponentType, useState, useEffect } from "react"
import { useRehydratedCheck } from "hooks-lib/useRehydratedCheck"

// Higher-order component (HOC) to provide hydration state to components
// This is for use with class components that can't use hooks
export const withHydration = <P extends object>(
  Component: ComponentType<P>,
): React.FC<P> =>
  function HydratedComponent(props: P) {
    const [isReady, setIsReady] = useState(false)
    const { isReady: useReadyCheckResult } = useRehydratedCheck() as {
      [x: string]: boolean
    }

    useEffect(() => {
      let timerId: NodeJS.Timeout

      if (!isReady && useReadyCheckResult) {
        // there is something weird with the component updating/hydration in class components, adding a slight delay to ensure proper behavior
        timerId = setTimeout(() => setIsReady(true), 500)
      }

      // handle cleanup of timers when the component unmounts
      return () => {
        if (timerId) {
          clearTimeout(timerId)
        }
      }
    }, [isReady, useReadyCheckResult])

    return <Component {...props} isReady={isReady} />
  }

export default withHydration
